import { initializeEvaluations } from 'slices/evaluationSlice'
import { initializeActiveLocations } from 'slices/locationSlice'
import { initializeMyProjects } from 'slices/projectSlice'
import { initializeTaskCNs } from 'slices/taskCNSlice'
import type { AiPlanView } from 'services/aiService'

/**
 * After a plan runs or is undone, the lists it changed are read again, so the
 * Locations, Projects, Tasks and Evaluations screens show the change without
 * a reload (MYD-624).
 *
 * Driven by what the plan's steps DO, not by what they returned, so an undo,
 * which reports no records, refreshes the same lists the run did. Each read
 * is that slice's own list thunk; a failure is that slice's to report.
 */

const LISTS_BY_OP: Record<string, ('locations' | 'projects' | 'tasks' | 'evaluations')[]> = {
	'location.create': ['locations'],
	'project.create': ['projects'],
	'asset.addPartner': ['locations', 'projects'],
	'task.create': ['tasks'],
	'task.applyTemplate': ['tasks'],
	'evaluation.create': ['evaluations'],
	'evaluationSite.addFromLocation': ['evaluations'],
	'evaluationSite.addFromPlace': ['evaluations'],
	'portfolio.addLocation': ['locations'],
}

/** Which lists a plan's steps touch. */
export const listsTouchedBy = (view: Pick<AiPlanView, 'plan'>) => [...new Set(view.plan.steps.flatMap(step => LISTS_BY_OP[step.op] ?? []))].sort()

export const refreshListsAfter = (dispatch: (action: any) => unknown, view: Pick<AiPlanView, 'plan'>, userId?: string) => {
	for (const list of listsTouchedBy(view)) {
		if (list === 'locations') dispatch(initializeActiveLocations())
		else if (list === 'projects') dispatch(initializeMyProjects())
		else if (list === 'tasks' && userId) dispatch(initializeTaskCNs({ userid: userId }))
		else if (list === 'evaluations') dispatch(initializeEvaluations(undefined))
	}
}
